/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { empty, errorResponse, isObject, prepareResponseData } from "../../Utilities/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import studentsApi from "../../api/Student";
import classApi from "../../api/Classes";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { FaMinus, FaPlus } from "react-icons/fa";
import TableLoading from "../../components/skeleton/TableLoading";
import colors from "../../config/colors";

const AssignStudentsToStream = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  //ref
  const toastTR = useRef(null);
  // states
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [streamStudents, setStreamStudents] = useState([]);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [studentIds, setStudentIds] = useState([]);
  const [classData, setClassData] = useState("");
  const [checked, setChecked] = useState(false);
  const [showAssignButton, setShowAssignButton] = useState(false);
  const { classId, streamId } = useParams();

  useEffect(() => {
    if (!classId || !streamId) {
      navigate("/404");
    }
    // fetch class details
    getClassDetails();
    getStudents();
  }, []);

  useEffect(() => {
    if (empty(selectedStudentIds)) {
      return setShowAssignButton(false);
    }
    setShowAssignButton(true);
  }, [selectedStudentIds]);


  const getStudents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentsApi.getStudentsInClass(
        schoolId,
        null,
        1000,
        null,
        classId,
        "list"
        );
      const response_data = prepareResponseData(response);
      if (
        !response_data?.success
      ) {
        return setStudents([]);
      }
        const results =
            !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        let updateStudentIds = [];
        let updatedResults = [];
        const streamStudentsData = [];
        for (let i = 0; i < results.length; i++) {
            const studentId = results?.[i]?._id || "";
            updateStudentIds.push(studentId);
            results[i].added = results?.[i]?.classStreamId === streamId;
            if (results[i].added) {
                streamStudentsData.push(results?.[i]?._id);
            }
            updatedResults.push(results[i]);
        }
        setStudentIds(updateStudentIds);
        setStudents(updatedResults);
        setStreamStudents(streamStudentsData);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get class details
   */
  const getClassDetails = async () => {
    try {
        const response = await classApi.getSingleClass(classId, streamId);
        const response_data = prepareResponseData(response);
        if (!response_data?.success) {
            return responseDialog(
            "error",
            "Error Alert",
            response_data?.response || "Failed to fetch class details"
            );
        }
        setClassData(isObject(response_data?.response) ? response_data.response : "");
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  const updateSelectedStudentIds = (
    studentId,
    sideAction = false,
    add = false
  ) => {
    try {
      let updateStudents = [];
      if (sideAction) {
        let action = "assign";
        updateStudents = [studentId];
        action = add ?  "assign" : "remove";
        toggleStudentsInStream(action, updateStudents, sideAction);
      } else {
        const index = selectedStudentIds.indexOf(studentId);
        if (index > -1) {
          updateStudents = selectedStudentIds.filter((id) => id !== studentId);
        } else {
          updateStudents = [...selectedStudentIds, studentId];
        }
        setSelectedStudentIds(updateStudents);
        if (updateStudents.length !== studentIds.length) {
          setChecked(false);
        } else {
          setChecked(true);
        }
      }
    } catch (error) {}
  };

  const toggleStudentsInStream = async (
    action = "assign",
    updatedStudents = [],
    sideAction = false
  ) => {
    try {
        if (!isActionLoading) setIsActionLoading(true);
        let dataToUpdate = [];
        if (!sideAction) {
            if (action === "assign") {
            if (
                selectedStudentIds.every((item) => streamStudents.includes(item))
            ) {
                dataToUpdate = selectedStudentIds;
            } else {
                dataToUpdate = [
                ...new Set([...streamStudents, ...selectedStudentIds]),
                ];
            }
            } else {
                const filteredArray = streamStudents.filter(
                    (item) => !selectedStudentIds.includes(item)
                );
                dataToUpdate = filteredArray;
            }
        } else {
            dataToUpdate = updatedStudents;
        }
        const response = await classApi.toggleStudentsClassStream(
            {
                student_ids: dataToUpdate,
                class_id: classId,
                stream_id: streamId,
                action
            }
        );
        const response_data = prepareResponseData(response);
        setSelectedStudentIds([]);
        if (
            empty(response_data) ||
            empty(response_data.success) ||
            !response_data.success
        ) {
            return responseDialog(
            "error",
            "Something went wrong",
            !empty(response_data) && !empty(response_data.response)
                ? response_data.response
                : "Operation failed"
            );
        }
        responseDialog("success", "Success", "Operation successful");
        return getStudents();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  const actionBodyTemplate = (rowData) => {
    const added = rowData?.classStreamId === streamId;
    const studentId =
      !empty(rowData) && !empty(rowData._id) && rowData._id
        ? rowData._id
        : false;
    return (
      <Button
        icon={added ? "pi pi-minus" : "pi pi-plus"}
        style={{
          backgroundColor: "transparent",
          color: added ? colors.danger : colors.success,
          borderColor: added ? colors.danger : colors.success,
          borderWidth: 1,
          borderRadius: "50%",
          width: 35,
          height: 35
        }}
        onClick={() => {
          updateSelectedStudentIds(studentId, true, !added);
        }}
      />
    );
  };

  const checkBoxBodyTemplate = (rowData) => {
    const studentId = !empty(rowData) && !empty(rowData._id) ? rowData._id : "";
    return (
      <Checkbox
        checked={selectedStudentIds.includes(studentId)}
        onChange={() => updateSelectedStudentIds(studentId)}
      />
    );
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            <MainHeader
              children={
                showAssignButton ? (
                  <>
                    <ButtonIcon
                      borderColor={colors.success}
                      backgroundColor={colors.success}
                      color={colors.white}
                      icon={<FaPlus style={{ fontSize: 12 }} />}
                      buttonText="Assign"
                      marginRight={1}
                      iconMarginRight={5}
                      width={90}
                      height={30}
                      onClick={() => toggleStudentsInStream("assign")}
                    />
                    <ButtonIcon
                      borderColor={colors.danger}
                      backgroundColor={colors.danger}
                      color={colors.white}
                      iconMarginRight={5}
                      icon={<FaMinus style={{ fontSize: 12 }} />}
                      buttonText="Remove"
                      width={100}
                      height={30}
                      onClick={() => toggleStudentsInStream("remove")}
                    />
                  </>
                ) : (
                  ""
                )
              }
                redirect={false}
                title={
                    <span>Assign/Remove Students(s) from  { classData?.currentStreamTitle ? <NavLink to={`/classes/${streamId}/profile`} style={{ color: colors.primary, fontWeight: 'bold' }}>{classData.currentStreamTitle}</NavLink> : '--' } a sub/stream class of <NavLink to={`/classes/${classId}/profile`} style={{ color: colors.primary, fontWeight: 'bold' }}>{classData.title}</NavLink> 
                    </span>
                }
            />
            <div style={{ marginBottom: 10 }}>
              <span style={{ marginRight: 40 }}>
                <strong>No. of Students In main class: </strong>
                {students.length}
              </span>
              <span style={{ marginRight: 40 }}>
                <strong>No. of Students In stream class: </strong>
                {streamStudents.length}
              </span>
              <span>
                <strong>No. of Selected Students: </strong>
                {selectedStudentIds.length}
              </span>
            </div>
            {!isLoading ? (
              <DataTable value={students} tableStyle={{ minWidth: "30rem" }} 
                key={selectedStudentIds.join("-")} >
                <Column
                  field="_id"
                  header={
                    <Checkbox
                      checked={checked}
                      onChange={(e) => {
                        setChecked(e.checked);
                        setSelectedStudentIds(e.checked ? [...studentIds] : []);
                        setShowAssignButton(e.checked && studentIds.length > 0);
                      }}
                    />
                  }
                  body={checkBoxBodyTemplate}
                />
                <Column field="fullName" header="Full Name" />
                <Column field="gender" header="Gender" />
                <Column
                  field="added"
                  header="Action"
                  body={actionBodyTemplate}
                />
              </DataTable>
            ) : (
              <TableLoading cols={4} rows={20} />
            )}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </AppWrapper>

      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default AssignStudentsToStream;
